import React from 'react';

const CampaignDetailContext = React.createContext();

export default CampaignDetailContext;
